import { z } from "zod";

export const createPaqueteSchema = z.object({
  idPrograma: z.number().int().positive(),
  cantidadLearners: z.number().int().min(1),
  fechaInicio: z.coerce.date(),
  fechaVencimiento: z.coerce.date(),
});

export type CreatePaqueteInput = z.infer<typeof createPaqueteSchema>;

export const updatePaqueteSchema = createPaqueteSchema.extend({
  id: z.number().int().positive(),
});

export type UpdatePaqueteInput = z.infer<typeof updatePaqueteSchema>;
